module.exports = __webpack_public_path__ + "static/media/schody24 - schody drewniane lakierowane z podestem.37d9a495.jpg";